export default __webpack_public_path__ + "static/media/logo-acae-completo.48649027.png";